export const MFE_DIALOG_PREFIX = 'ENGINE-OIL-DIALOGS';
